import Immutable from 'immutable';

import {
  FETCH_COURSE_ADMIN_DATA_SUCCESS,
  FETCH_COURSE_LANDING_PAGE_DATA_SUCCESS,
  SAVE_COURSE_LANDING_PAGE_START,
  SAVE_COURSE_LANDING_PAGE_SUCCESS,
  SAVE_COURSE_LANDING_PAGE_FAILURE,
  COPY_COURSE_START,
  COPY_COURSE_SUCCESS,
  HIDE_COPY_COURSE_SUCCESS_MODAL,
  COPY_COURSE_FAILURE,
  HIDE_COPY_COURSE_ERROR_MODAL,
  ADD_COURSE_LANDING_PAGE_TEAM_MEMBER,
  UPDATE_COURSE_LANDING_PAGE_MEDIA,
  REMOVE_COURSE_LANDING_PAGE_TEAM_MEMBER,
  UPDATE_COURSE_LANDING_PAGE_BLURB,
  UPDATE_COURSE_LANDING_PAGE_OUTCOMES_SUMMARY,
  UPDATE_COURSE_LANDING_PAGE_INTRODUCTION,
  UPDATE_COURSE_LANDING_PAGE_FURTHER_INFORMATION,
  UPDATE_COURSE_LANDING_PAGE_CPD_HOURS,
  TOGGLE_COURSE_LANDING_PAGE_HIDE_COST,
  UPDATE_COURSE_LANDING_DEFAULT_COHORT,
  FETCH_CERTIFICATION_SETUP_DATA_SUCCESS,
  UPDATE_CERTIFICATION_TYPE,
  UPDATE_CERTIFICATION_CODE,
  UPDATE_CERTIFICATION_DATA,
  SAVE_CERTIFICATION_START,
  SAVE_CERTIFICATION_SUCCESS,
  SAVE_CERTIFICATION_FAILURE,
  FETCH_ACCREDIBLE_DESIGNS_SUCCESS,
  GET_COURSE_STRIPE_CONNECT_CONTEXT_SUCCESS,
} from './actions';
import { COURSE_NAVIGATION_DATA_SET } from '../CourseNavigationInfo/actions';
import {
  OPENLEARNING_CERTIFICATION_SET,
  FREE_CERTIFICATE_SET,
  OPEN_CRED_CERTIFICATE_SET,
  DIGITAL_CERTIFICATE_SET,
  OPENLEARNING_PDF_CERTIFICATE_SET,
  ACCREDIBLE_CERTIFICATE_SET,
} from '../Certification/constants';
import { validateCertificationData } from './helpers';

const INITIAL_STATE = Immutable.fromJS({
  accessEmails: {
    // path: bool
  },
  landingPage: {},
  courseCopy: {},
  certification: {
    /*
      type,
      code,
      data,
    */
  },
});

const updateLandingPage = (state, action, isSaving = false) => {
  const { coursePath, landingPageData } = action;
  let data = Immutable.fromJS(landingPageData);
  data = data.updateIn(['teamMembers'], (teamMembers) =>
    teamMembers.map((tm) => tm.get('profileName'))
  );

  return state.setIn(
    ['landingPage', coursePath],
    Immutable.Map({
      isSaving,
      data,
    })
  );
};

const updateLandingPageData = (state, coursePath, changes) => {
  return state.mergeIn(
    ['landingPage', coursePath, 'data'],
    Immutable.fromJS(changes)
  );
};

export const CourseAdminUI = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COURSE_ADMIN_DATA_SUCCESS: {
      return state.setIn(
        ['accessEmails', action.coursePath],
        action.canAccessEmails
      );
    }
    case FETCH_COURSE_LANDING_PAGE_DATA_SUCCESS: {
      return updateLandingPage(state, action);
    }
    case ADD_COURSE_LANDING_PAGE_TEAM_MEMBER: {
      const {
        coursePath,
        teamMember: { profileName },
      } = action;
      return state.updateIn(
        ['landingPage', coursePath, 'data', 'teamMembers'],
        (teamMembers) => teamMembers.push(profileName)
      );
    }
    case REMOVE_COURSE_LANDING_PAGE_TEAM_MEMBER: {
      const { coursePath, profileName } = action;
      return state.updateIn(
        ['landingPage', coursePath, 'data', 'teamMembers'],
        (teamMembers) => teamMembers.filter((tm) => tm !== profileName)
      );
    }
    case UPDATE_COURSE_LANDING_PAGE_MEDIA: {
      const { coursePath, promoImageUrl, promoVideoUrl, mediaType } = action;
      return state.mergeIn(['landingPage', coursePath, 'data'], {
        promoImageUrl,
        promoVideoUrl,
        mediaType,
      });
    }
    case UPDATE_COURSE_LANDING_PAGE_BLURB: {
      const { coursePath, blurb } = action;
      return updateLandingPageData(state, coursePath, { blurb });
    }
    case UPDATE_COURSE_LANDING_PAGE_OUTCOMES_SUMMARY: {
      const { coursePath, summary } = action;
      return updateLandingPageData(state, coursePath, { summary });
    }
    case UPDATE_COURSE_LANDING_PAGE_INTRODUCTION: {
      const { coursePath, introduction } = action;
      return updateLandingPageData(state, coursePath, { introduction });
    }
    case UPDATE_COURSE_LANDING_PAGE_FURTHER_INFORMATION: {
      const { coursePath, furtherInformation } = action;
      return updateLandingPageData(state, coursePath, { furtherInformation });
    }
    case UPDATE_COURSE_LANDING_PAGE_CPD_HOURS: {
      const { coursePath, CpdHours } = action;
      return updateLandingPageData(state, coursePath, { CpdHours });
    }
    case TOGGLE_COURSE_LANDING_PAGE_HIDE_COST: {
      const { coursePath } = action;
      return state.updateIn(
        ['landingPage', coursePath, 'data', 'hideCost'],
        (hideCost) => !hideCost
      );
    }
    case UPDATE_COURSE_LANDING_DEFAULT_COHORT: {
      const { coursePath, defaultCohortPath } = action;
      return updateLandingPageData(state, coursePath, { defaultCohortPath });
    }
    case SAVE_COURSE_LANDING_PAGE_START: {
      const { coursePath } = action;
      return state.setIn(['landingPage', coursePath, 'isSaving'], true);
    }
    case SAVE_COURSE_LANDING_PAGE_SUCCESS: {
      return updateLandingPage(state, action);
    }
    case SAVE_COURSE_LANDING_PAGE_FAILURE: {
      return state.setIn(['landingPage', action.coursePath, 'isSaving'], false);
    }
    case COPY_COURSE_START: {
      const { coursePath } = action;
      return state.setIn(
        ['courseCopy', coursePath],
        Immutable.fromJS({
          isLoading: true,
        })
      );
    }
    case COPY_COURSE_SUCCESS: {
      const { coursePath } = action;
      return state.mergeIn(
        ['courseCopy', coursePath],
        Immutable.fromJS({
          showSuccessModal: true,
        })
      );
    }
    case COPY_COURSE_FAILURE: {
      const { coursePath } = action;
      return state.mergeIn(['courseCopy', coursePath], {
        isLoading: false,
        showErrorModal: true,
      });
    }
    case HIDE_COPY_COURSE_SUCCESS_MODAL: {
      const { coursePath } = action;
      return state.setIn(['courseCopy', coursePath, 'showSuccessModal'], false);
    }
    case HIDE_COPY_COURSE_ERROR_MODAL: {
      const { coursePath } = action;
      return state.setIn(['courseCopy', coursePath, 'showErrorModal'], false);
    }
    case COURSE_NAVIGATION_DATA_SET: {
      const { certification, coursePath } = action;
      return state.mergeIn(
        ['certification', coursePath],
        Immutable.fromJS({ ...certification, pristine: true })
      );
    }
    case FETCH_CERTIFICATION_SETUP_DATA_SUCCESS: {
      const {
        coursePath,
        certificationTypes,
        currencyOptions,
        certificateOptions,
      } = action;
      return state.mergeIn(
        ['certification', coursePath],
        Immutable.fromJS({
          certificationTypes,
          currencyOptions,
          certificateOptions,
        })
      );
    }
    case UPDATE_CERTIFICATION_TYPE: {
      const { coursePath, certificationType, courseUrl, courseName } = action;
      const currentType = state.getIn(['certification', coursePath, 'type']);
      let data = {};
      const isSameType = (current, change) => {
        // one type with a choice of Free/Paid
        return (
          (OPEN_CRED_CERTIFICATE_SET.has(current) &&
            OPEN_CRED_CERTIFICATE_SET.has(change)) ||
          (OPENLEARNING_PDF_CERTIFICATE_SET.has(current) &&
            OPENLEARNING_PDF_CERTIFICATE_SET.has(change)) ||
          (DIGITAL_CERTIFICATE_SET.has(current) &&
            DIGITAL_CERTIFICATE_SET.has(change))
        );
      };

      if (OPENLEARNING_CERTIFICATION_SET.has(certificationType)) {
        if (isSameType(currentType, certificationType)) {
          // preserve all the data between these two types
          // because in the UI it is presented as one type with a choice of Free/Paid
          // even though on the server side it is represented as two
          data = state.getIn(['certification', coursePath, 'data']).toJS();
        } else {
          data.name = 'Certificate of completion';
          data.automaticallyIssueCertificate = true;
        }
      }

      if (
        ACCREDIBLE_CERTIFICATE_SET.has(certificationType) &&
        !ACCREDIBLE_CERTIFICATE_SET.has(currentType)
      ) {
        data.displayName = courseName;
        data.website = courseUrl;
      }

      return state.mergeIn(
        ['certification', coursePath],
        Immutable.fromJS({
          type: certificationType,
          code: '',
          data,
          errors: {},
          pristine: false,
        })
      );
    }
    case UPDATE_CERTIFICATION_CODE: {
      const { coursePath, code } = action;
      return state.mergeIn(
        ['certification', coursePath],
        Immutable.fromJS({
          code,
          pristine: false,
        })
      );
    }
    case UPDATE_CERTIFICATION_DATA: {
      const { coursePath, changes } = action;

      return state.updateIn(
        ['certification', coursePath],
        Immutable.Map(),
        (certificationData) => {
          const dataChanges = Immutable.fromJS(changes);
          const updatedCertificationData = certificationData.mergeIn(
            ['data'],
            dataChanges
          );

          // check if these changes fix any displayed validation errors
          let errors = certificationData.get('errors', Immutable.Map());
          const updatedErrors = validateCertificationData(
            updatedCertificationData
          );

          dataChanges.keySeq().forEach((key) => {
            if (errors.has(key) && !updatedErrors.has(key)) {
              errors = errors.delete(key);
            }
          });

          return updatedCertificationData.merge({
            pristine: false,
            errors,
          });
        }
      );
    }
    case SAVE_CERTIFICATION_START: {
      const { coursePath, isOpenCred } = action;
      const certification = state.getIn(['certification', coursePath]);
      let data = certification.get('data');

      if (FREE_CERTIFICATE_SET.has(certification.get('type'))) {
        // make sure we only save fields that are relevant to this type
        const defaultFields = [
          'name',
          'automaticallyIssueCertificate',
          'certificationPendingMessage',
          'certificationAwardedMessage',
        ];
        let allowedFields = defaultFields;

        if (
          ACCREDIBLE_CERTIFICATE_SET.has(certification.get('type')) ||
          isOpenCred
        ) {
          const accredibleFields = ['displayName', 'description', 'website'];
          allowedFields = defaultFields.concat(accredibleFields);
        }

        data = data.filter((value, key) => allowedFields.includes(key));
      }

      return state.mergeIn(
        ['certification', coursePath],
        Immutable.fromJS({
          data: data.toJS(),
          isSaving: true,
          errors: {},
        })
      );
    }
    case SAVE_CERTIFICATION_SUCCESS: {
      const { coursePath, certificationData } = action;
      return state.mergeIn(
        ['certification', coursePath],
        Immutable.fromJS({
          ...certificationData,
          isSaving: false,
          pristine: true,
        })
      );
    }
    case SAVE_CERTIFICATION_FAILURE: {
      const { coursePath, errors } = action;
      return state.mergeIn(
        ['certification', coursePath],
        Immutable.fromJS({ isSaving: false, errors })
      );
    }
    case FETCH_ACCREDIBLE_DESIGNS_SUCCESS: {
      const { coursePath, accredibleDesigns } = action;
      return state.mergeIn(
        ['certification', coursePath],
        Immutable.fromJS({ accredibleDesigns })
      );
    }
    case GET_COURSE_STRIPE_CONNECT_CONTEXT_SUCCESS: {
      const { coursePath, context } = action;
      const { currency, status } = context;
      return state
        .setIn(['stripeConnectContext', coursePath, 'currency'], currency)
        .setIn(['stripeConnectContext', coursePath, 'status'], status);
    }
    default: {
      return state;
    }
  }
};
